// src/components/ImageEditor/uploadEditedImage.js
//
// Uploads an edited image blob and returns a file ref in the same shape every
// upload path in the app already produces, so a cropped image can be swapped
// into a gold-image list, a document slot or a photo field interchangeably.

import API from '../../services/api';
import { headerSafeFileName } from '../../utils/headerSafeFileName';

/**
 * @param {Blob} blob
 * @param {Object} opts { fileName, folderPath }
 * @returns {Promise<{fileId,url,thumbnailUrl,filePath,name}>}
 */
export const uploadEditedImage = async (blob, { fileName, folderPath } = {}) => {
  const name = fileName || `edited-${Date.now()}.jpg`;
  const headers = {
    'Content-Type': 'application/octet-stream',
    'x-file-name': headerSafeFileName(name),
  };
  if (folderPath) headers['x-folder-path'] = folderPath;

  const res = await API.post('/uploads/buffer', blob, {
    headers,
    transformRequest: [(data) => data],
    maxBodyLength: Infinity,
  });

  const payload = res.data?.data || res.data;
  if (!payload?.url) throw new Error(res.data?.message || 'Upload of the edited image failed');
  return {
    fileId: payload.fileId,
    url: payload.url,
    thumbnailUrl: payload.thumbnailUrl,
    filePath: payload.filePath,
    name: payload.name || name,
  };
};

export default uploadEditedImage;
